<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.setting')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="items">
			<div class="item van-hairline--bottom" @click="toInfomation()">
				<div class="left">{{$t("other.basic_info")}}</div>
				<van-icon name="arrow" />
			</div>
			<div class="item van-hairline--bottom" @click="toLoginPassword()">
				<div class="left">{{$t("other.login_password")}}</div>
				<van-icon name="arrow" />
			</div>
			<div class="item van-hairline--bottom" @click="toPayPassword()">
				<div class="left">{{$t("other.fund_password")}}</div>
				<div class="right">
					<!-- 	<span class="desc">{{this.userInfo.paypassword}}</span> -->
					<van-icon name="arrow" />
				</div>
			</div>
			<div class="item van-hairline--bottom" @click="toLanguage()">
				<div class="left">{{$t("setting.language")}}</div>
				<div class="right">
					<van-icon name="arrow" />
				</div>
			</div>
		</div>
		<van-button class="sign-out" type="primary" size="normal"
			@click="loginout()">{{$t("other.logout")}}</van-button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo: {}
			};
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			back() {
				return window.history.back();
			},
			//资金密码
			toPayPassword() {
				if (this.userInfo.has_pay_password) {
					this.$toast(this.$t("other.fund_password_set_tip"));
				} else {
					this.$router.push({
						path: '/SetPayPassword'
					});
				}
			},
			//登录密码
			toLoginPassword() {
				this.$router.push({
					path: '/SetLoginPassword'
				});
			},
			//切换语言
			toLanguage() {
				this.$router.push({
					name: 'Language',
					params: {
						"type": "setting"
					}
				});
			},
			//基本信息
			toInfomation() {
				this.$router.push({
					path: '/Infomation'
				});
			},
			//退出
			loginout() {
				localStorage.clear()
				this.$router.push({
					path: '/login'
				});
			},
			//用户信息
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data;
					} else {
						this.$toast(res.msg);
					}
				})
			}
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.container .items {
		background-color: #fff;
		font-size: 30px;
		color: #000;
		padding: 0 25px;
	}

	.container .items .item {
		padding: 30px 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-bottom-width: 10px;
	}

	.container .items .van-hairline--bottom::after {
		border-bottom-width: 3px;
	}

	.container .sign-out {
		margin: 500px 20px 0;
		height: 100px;
		line-height: 100px;
		border-radius: 50px;
		color: #fff;
		font-size: 40px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(270deg, #e6c3a1, #7e5678);
	}

	.container .item .desc {
		font-size: 30px;
		font-weight: 700;
		color: #979799;
	}

	.container .item .right {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>